/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * A directive for adding infinite scrolling to the perfect-scrollbar plugin.
 */
angular.module('bulbApp.utilsModule')

.directive('bulbInfiniteScroll', ['$window', bulbInfiniteScroll]);

function bulbInfiniteScroll($window) {
  return {
    restrict: 'A',
        scope: {
            bulbInfiniteScroll: '&'
        },
    link: function(scope, elem, attr) {
            var scrollWindowEvent = function() {
        // if the bottom of the element is above the bottom of the viewport
        // (may be above the top of the viewport)
                if (elem.offset().top + elem.height() < ($window.scrollY + jQuery($window).height())) {
                    scope.bulbInfiniteScroll();
                }
            };

            var raw = elem[0];

            scope.$watch(attr.bulbThemedScrollbar, function() {
                var val = attr.bulbThemedScrollbar;
                if (val !== 'false') {
                    jQuery(window).unbind('scroll.infiniteScroll', scrollWindowEvent);
                    // Trigger events when the bottom is reached, for infinite scrolling.
                    var atBottom = false;
                    elem.on('scroll', function () {
                      // When we get within half a 'page' of the bottom, we fetch the next set of items.
                        if (raw.scrollTop + (raw.offsetHeight * 1.5) >= raw.scrollHeight) {
                            // Check if the scroll bar is already at the bottom before triggering the infinite scroll function.
                            if (!atBottom) {
                                scope.bulbInfiniteScroll();
                                atBottom = true;
                            }
                        } else {
                            atBottom = false;
                        }
                    });
                } else {
                    elem.unbind('scroll');
                    scope.$watch(function() { return elem.is(':visible'); }, function(isVisible) {
                        if (isVisible) {
                            jQuery(window).on('scroll.infiniteScroll', scrollWindowEvent);
                        } else {
                            jQuery(window).unbind('scroll.infiniteScroll');
                        }
                    });
                }
            });
    }
  };
}
